module.exports = __webpack_public_path__ + "static/img/bg_left.378e7c2d.png";